import { createPortal } from "react-dom";
import { SideModal } from "shared";
import { CompanyMyType } from "types/CompanyTypes";
import "./TransactionsSideModal.scss";
import TransactionsTable from "./components/TransactionsTable";
import { useGetMe } from "hooks/auth";
import { SharesByCompanyType } from "types/SharesTypes";
import { Button } from "shared";
import { isDesktop, formatNumber } from "utils";
import { useGetTransaction } from "hooks/transactions";

interface TransactionsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyMyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
  onAddTransactionClick: () => void;
  isOtherTab?: boolean;
  isArchived?: boolean;
}

const TransactionsSideModal: React.FC<TransactionsSideModalProps> = ({
  isOpen,
  onClose,
  company,
  setEditTransaction,
  onAddTransactionClick,
  isOtherTab = false,
  isArchived = false,
}) => {
  const client =
    company && company.shares && company.shares[0] && company?.shares[0]?.user;
  const { data: authorizedUser } = useGetMe();
  const isAdmin = authorizedUser?.role === "admin";
  const shareId = company?.shareId
    ? String(company.shareId)
    : company?.shares?.[0]?.id
    ? String(company?.shares[0].id)
    : "";
  const { data } = useGetTransaction(shareId);

  return createPortal(
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        isAdmin ? (
          <>
            <p>
              <b>Spółka:</b> {company?.name || "-"} |
              {isOtherTab && (
                <>
                  {" "}
                  <b>Klient:</b> {client?.name || "-"}
                </>
              )}
              {client?.name || "-"}
            </p>
            <p className="transactions-side-modal__counter">
              Obecna ilość sztuk: <b>{formatNumber(company?.sharesCount)}</b>
            </p>
          </>
        ) : (
          <>
            <p>
              <b>Spółka:</b> {company?.name || "-"}{" "}
            </p>
            <p className="side-modal__subtitle--count">
              Obecna ilość {company?.type === "share" ? "udziałów" : "akcji"}:{" "}
              <span>{formatNumber(data?.[0].allCount)}</span>
            </p>
          </>
        )
      }
      className="company-info-modal wide"
    >
      <>
        {!isArchived && (
          <Button
            className="button--rounded company-info-modal__button"
            onClick={onAddTransactionClick}
            label="Dodaj transakcję  +"
            styleType={isDesktop() ? undefined : "primary"}
          />
        )}
        <TransactionsTable
          isAdmin={isAdmin}
          company={company}
          setEditTransaction={setEditTransaction}
        />
      </>
    </SideModal>,
    document.body,
  );
};

export default TransactionsSideModal;
